import { computed } from 'mobx';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { OData, $data } from 'src/core/services/data/JayDataContext';
import { ContextService } from 'src/core/services/context.service';
import { FormatService } from 'src/core/services/format.service';

export class AllotmentRangeDataService extends DataService<typeof Model.Products.Logic.ViewModels.AllotmentRangeItem, Model.Products.Logic.ViewModels.AllotmentRangeItem, AllotmentRangeItem> {
	id: number = 0;

	constructor(contextService: ContextService, entitySet: (context: OData.Container) => $data.EntitySet<typeof Model.Products.Logic.ViewModels.AllotmentRangeItem, Model.Products.Logic.ViewModels.AllotmentRangeItem>, private formatService: FormatService) {
		super(contextService, entitySet, false);
	}

	protected map(entity: Model.Products.Logic.ViewModels.AllotmentRangeItem): AllotmentRangeItem {
		return new AllotmentRangeItemModel(entity, this.formatService);
	}

	public add(allotment: AllotmentItem, defaultLanguage: string) {
		const entity = new Model.Products.Logic.ViewModels.AllotmentRangeItem();
		entity.allotmentId = allotment.id;
		entity.dateFrom = new Date();
		entity.dateTo = new Date();
		entity.allotmentRangeType = 2;
		entity.id = --this.id;
		(entity as any).dynamicProperties['translations'] = {
			[defaultLanguage]: '',
		};

		return this.create(() => entity);
	}

	public static make(context?: any, formatService?: FormatService): AllotmentRangeDataService {
		return new AllotmentRangeDataService(context, ctx => ctx.AllotmentRanges, formatService);
	}
}

export class AllotmentRangeItemModel extends EntityModel<Model.Products.Logic.ViewModels.AllotmentRangeItem, AllotmentRangeItem> implements AllotmentRangeItem {
	@property<AllotmentRangeItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<AllotmentRangeItemModel>(o => o.entity.allotmentRangeType, (o, value) => o.entity.allotmentRangeType = value)
	public allotmentRangeType: number;

	@property<AllotmentRangeItemModel>(o => o.entity.dateFrom, (o, value) => o.entity.dateFrom = value)
	public dateFrom: Date;

	@property<AllotmentRangeItemModel>(o => o.entity.dateTo, (o, value) => o.entity.dateTo = value)
	public dateTo: Date;

	@property<AllotmentRangeItemModel>(o => o.entity.allotmentId, (o, value) => o.entity.allotmentId = value)
	public allotmentId: number;

	@property<AllotmentRangeItemModel>(o => o.entity.totalLimit, (o, value) => o.entity.totalLimit = value)

	public totalLimit?: number;

	@property<AllotmentRangeItemModel>(o => o.entity.dailyLimit, (o, value) => o.entity.dailyLimit = value)

	public dailyLimit?: number;

	@property<AllotmentRangeItemModel>(o => o.entity.allotment, (o, value) => o.entity.allotment = value)

	public allotment: any;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: {};

	@property<AllotmentRangeItemModel>(o => o.entity.allotmentRangeDailies, (o, value) => o.entity.allotmentRangeDailies = value)
	public allotmentRangeDailies: any[];

	@computed
	public get dateFromToText(): string {
		return this.formatService.toString('short-date', this.dateFrom, "utc");
	}

	@computed
	public get allotmentRangeTypeToText(): string {
		switch (this.allotmentRangeType) {
			case 0:
				return 'StopSale';
			case 1:
				return 'By Availability';
			case 2:
				return 'By Request';
			case 3:
				return 'Unavailable';
			case 4:
				return 'Freesell';
			default:
				return 'UNDEFINDED';
		}
	}

	@computed
	public get dateToToText(): string {
		return this.formatService.toString('short-date', this.dateTo, "utc");
	}

	constructor(entity: Model.Products.Logic.ViewModels.AllotmentRangeItem, private formatService: FormatService) {
		super(entity);
	}
	public async validate(validateChildren: boolean, property?: string): Promise<ValidationError[]> {
		let result: ValidationError[] = [];
		if (this.allotmentRangeType == 1) {
			if (this.totalLimit == null && this.dailyLimit == null)
				result.push({
					property: 'totalLimit-dailyLimit',
					text: 'TotalLimit or DailyLimit must have value'
				});
		}// es requerido el total o daily
		if (this.dateFrom > this.dateTo)
			result.push({
				property: 'dateFrom-dateTo',
				text: 'Date From must be less than Date To '
			});
		return result;
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment-range/form/allotment-range-form.data.ts